import React, { forwardRef } from "react";
import "./CheckoutProduct.css";
import { useStateValue } from "./StateProvider";

const CheckoutProduct = forwardRef((props, ref) => {
  const [state, dispatch] = useStateValue();

  const removeFromCart = () => {
    dispatch({
      type: "REMOVE_FROM_CART",
      id: state.productId,
    });
  };

  return (
    <div className="productList" ref={ref}>
      <img
        className="product__image"
        src={props.data.image}
        alt="product__img"
      />
      <div className="product__details">
        <p className="product__title">{props.data.title}</p>
        <p className="product__price">
          <small>$</small>
          <strong>{props.data.price}</strong>
        </p>
        <div className="product__rate">
          {Array(props.data.rating)
            .fill()
            .map(() => {
              return <p>⭐</p>;
            })}
        </div>
        {!props.hiddenButton && (
          <button onClick={removeFromCart}>Remove from Cart</button>
        )}
      </div>
    </div>
  );
});

export default CheckoutProduct;
